<template>

    <div>
        <input :ref=" refName || false " type="text" v-model="userInput" :class=" classes ? classes : 'input' " :id="id" :placeholder=" placeholder " @keyup=" searchUsers ">
        <div class="box"
            v-if=" users.length ">
            <p class="is-size-7">
                <span class="dot" style="height:8px;width:8px;background-color: blue;"></span> Work Trader &nbsp;&nbsp;&nbsp;|&nbsp;&nbsp;&nbsp; <span class="dot" style="height:8px;width:8px;background-color: green;"></span> Active Member
            </p>
            <div class="cursor-pointer user-selection is-padded-05"
                v-for=" user in users "
                @click=" chooseUser(user) ">
                <xero-user
                    :classes="dropClasses || ''"
                    :image-size=" imageSize || '' "
                    :avatar=" $avatar_url(user.avatar, showName ? user.addressee : user.username) "
                    :username=" showName ? user.addressee : user.username "
                    :paying-member=" !!user.paying_member "
                    :is-work-trade=" !!user.is_work_trade "
                ></xero-user>
            </div>
        </div>
    </div>

</template>

<script>
    export default {
        name: 'Choose-User',
        props: {
            routeSearchUsers: {
                type: String,
                required: true
            },
            classes: {
                type: String,
                required: false
            },
            id: {
                type: String,
                required: false,
            },
            dropClasses: {
                type: String,
                required: false
            },
            imageSize: {
                type: String,
                required: false
            },
            refName: {
                type: String,
                required: false
            },
            placeholder: {
                type: String,
                required: false,
                default: ''
            },
            showName: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data() {
            return {
                userInput: '',
                users: []
            };
        },
        methods: {
            searchUsers: async function (event) {
                this.$http.post(this.routeSearchUsers, {
                    filter: this.userInput,
                    limit: 6,
                    _token: this.$store.state.csrfToken
                })
                    .then(response => {
                        this.$d('response');
                        this.$d(response);
                        if (response.data.hasErrors) {
                            this.$store.commit('errors', response.data.errors);
                        } else if (response.data.success === true) {
                            if (response.data.users) {
                                this.users = response.data.users;
                                if(event.keyCode === 13 && this.users.length === 1) this.chooseUser(this.users[0]);
                            }
                            else this.users = [];
                        } else {
                            this.$store.commit('error', response.data.message);
                        }
                    })
                    .catch(error => {
                        this.$displayError(error);
                    });
            },
            chooseUser: function(data) {
                this.userInput = '';
                this.users = [];
                this.$emit('select', data);
            }
        },
        mounted() {
            this.$nextTick(() => {
                if(this.refName) {
                    this.$refs[this.refName].focus();
                }
            });
        }
    }
</script>


<style scoped>

    .user-username {
        line-height: 48px;
    }
    .user-selection:hover {
        background-color: #DBDBDB;
    }

    @media only screen and (max-width: 1023px) {
        .user-username {
            line-height: inherit;
        }
    }

</style>
